import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "storybookComponents/Typography";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { Collapse } from "reactstrap";
const useStyles = makeStyles((theme) => ({
  root: {
    width: 660,
    background: "white !important",
    borderRadius: "0 !important",
    boxShadow: "none",
    border: "2px solid #e3dede",
  },
  heading: {
    fontSize: 20,
    color: "black",
    fontFamily: "Open Sans",
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    "&:hover ": {
      background: "#26bbed0f",
    },
  },
  headerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "-webkit-fill-available",
    cursor: "pointer",
  },
  paper: {
    padding: 0,
  },
  paperContent: {
    width: "100%",
    padding: "0 40px 16px 40px",
  },
  openIcon: {
    transform: "rotate(90deg)",
  },
  subtitle: {
    fontSize: 16,
    color: "rgba(51,51,51,0.5)",
    lineHeight: "24px",
  },
  greyed: {
    backgroundColor: "#F9F9F9 !important",
  },
}));
export default function Expansion({
  expanded,
  name,
  handleExpandedPanel,
  header,
  headerIcon,
  subtitle,
  rightSection,
  children,
  greyed,
  className,
  defaultOpen,
  blockHeaderClick,
}) {
  const classes = useStyles();
  return (
    <div
      className={`${className && className.root ? className.root : classes.root} ${greyed && classes.greyed
        }`}
    >
      <div className={classes.header}>
        <div
          className={classes.headerLeft}
          onClick={blockHeaderClick ? () => { } : () => handleExpandedPanel(name)}
        >
          <ArrowRightIcon className={`${expanded && classes.openIcon}`} />
          <Typography className={classes.heading}>
            {typeof header === "function" ? header(expanded) : header}{" "}
            {headerIcon
              ? typeof headerIcon === "function"
                ? headerIcon(expanded)
                : headerIcon
              : null}
          </Typography>
        </div>
        <div>
          {rightSection
            ? typeof rightSection === "function"
              ? rightSection(expanded)
              : rightSection
            : null}
        </div>
      </div>
      <Collapse isOpen={expanded}>
        <div className={classes.paperContent}>
          {subtitle ? (
            <Typography className={classes.subtitle} type="subtitle" color="darkBlack">
              {subtitle}
            </Typography>
          ) : null}
          {children}
        </div>
      </Collapse>
    </div>
  );
}